import { StatusCheckmarkStatus } from '@ui/components/StatusCheckmark';

import { components as schoolComponents } from '@features/shared/api/school';
import { components } from '@features/shared/api/studio';

export type ILessonStatus = components['schemas']['LessonDevelopmentStatus'];

export type ISchoolRole = schoolComponents['schemas']['SchoolRole'];

// Роли с доступом к учебной программе: они же составляют список авторов
export const CURRICULUM_ROLES: ISchoolRole[] = ['Admin', 'BookAuthor'];

// Группа модуля: непрерывная последовательность уроков с одним названием модуля
export type IModuleGroup = {
  module: string;
  firstNumber: number;
  lastNumber: number;
  label: string;
};

// Порядок разработки урока — он же порядок пунктов в меню статуса
export const LESSON_STATUSES: ILessonStatus[] = ['InProgress', 'Completed', 'Approved'] as const;

export const LESSON_STATUS_LABELS: Record<ILessonStatus, string> = {
  InProgress: 'В работе',
  Completed: 'Завершен',
  Approved: 'Утвержден',
};

export const LESSON_STATUS_MARKS: Record<ILessonStatus, StatusCheckmarkStatus> = {
  InProgress: 'sending',
  Completed: 'sent',
  Approved: 'received',
};

// ----- Фильтры слайдов урока

// Живут на уровне фичи, а не страницы урока: список уроков ссылается на них
// из счетчиков, а маршрут проверяет ими search-параметр
export const FILTERS_SLIDE_TYPE = [
  { label: 'Все', value: 'all' },
  { label: 'Позиции', value: 'position' },
  { label: 'Задачи', value: 'test' },
  { label: 'Игры', value: 'game' },
  { label: 'Медия', value: 'media' },
] as const;

export type ISlideTypeFilter = (typeof FILTERS_SLIDE_TYPE)[number]['value'];

export const FILTERS_HOMEWORK_TYPE = [
  { label: 'ДЗ', value: 'homework' },
  { label: 'Доп. ДЗ', value: 'additional-homework' },
] as const;

export type IHomeworkTypeFilter = (typeof FILTERS_HOMEWORK_TYPE)[number]['value'];

export type ISlideFilter = ISlideTypeFilter | IHomeworkTypeFilter;

// Кортеж для z.enum: значения собраны из тех же списков, чтобы не разъезжались.
// Приведение утверждает лишь непустоту — ее гарантируют сами списки
export const SLIDE_FILTER_VALUES = [
  ...FILTERS_SLIDE_TYPE.map((f) => f.value),
  ...FILTERS_HOMEWORK_TYPE.map((f) => f.value),
] as [ISlideFilter, ...ISlideFilter[]];
